/**
 * @generated SignedSource<<dcb588f6798d4684670cf390e309a430>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type FunnelSourceCreateFormContainer_root$data = {
  readonly sources: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly name: string;
      } | null;
    } | null> | null;
  };
  readonly " $fragmentType": "FunnelSourceCreateFormContainer_root";
};
export type FunnelSourceCreateFormContainer_root = FunnelSourceCreateFormContainer_root$data;
export type FunnelSourceCreateFormContainer_root$key = {
  readonly " $data"?: FunnelSourceCreateFormContainer_root$data;
  readonly " $fragmentSpreads": FragmentRefs<"FunnelSourceCreateFormContainer_root">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "FunnelSourceCreateFormContainer_root",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "SourceConnection",
      "kind": "LinkedField",
      "name": "sources",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "SourceEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "Source",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "name",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "bd4565242c0d3f9039c4dce957ab744e";

export default node;
